import { ApiResponseStatusGlobalDisplay } from 'components/ApiResponseStatusGlobalDisplay/ApiResponseStatusGlobalDisplay';
import { PLATFORM_LEGAL_CORPORATION_ID } from 'services/api/constants';

import {
  HeaderBrandImage,
  HeaderTitle,
  LayoutBackgroundImage,
  LayoutBackgroundImageContainer,
  LayoutCardContainer,
  LayoutCardContentContainer,
  LayoutCardHeaderContainer,
  LayoutMainContainer,
} from './MainLayout.style';

interface MainLayoutProps {
  withBrand?: boolean;
  title?: string;
  children: React.ReactNode;
}

const HEADER_BRAND_LOGO_FILENAME = 'HeaderBrandLogo.png';

export const MainLayout = ({ withBrand, title, children }: MainLayoutProps) => {
  return (
    <LayoutMainContainer>
      <LayoutBackgroundImageContainer>
        <LayoutBackgroundImage
          src={`https://devcspdigitalpublicsa.blob.core.windows.net/b2c/${PLATFORM_LEGAL_CORPORATION_ID.toLowerCase()}/background.png`}
          alt=""
        />
      </LayoutBackgroundImageContainer>
      <LayoutCardContainer>
        {withBrand || title ? (
          <LayoutCardHeaderContainer>
            {withBrand ? (
              <HeaderBrandImage
                src={`${process.env.PUBLIC_URL}/config/${HEADER_BRAND_LOGO_FILENAME}`}
              />
            ) : null}
            {title ? <HeaderTitle>{title}</HeaderTitle> : null}
          </LayoutCardHeaderContainer>
        ) : null}
        <LayoutCardContentContainer>{children}</LayoutCardContentContainer>
      </LayoutCardContainer>
      <ApiResponseStatusGlobalDisplay />
    </LayoutMainContainer>
  );
};
